import styled from 'styled-components';
import { Loader } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { classnamePrefix } from '../../../../constants';
import { DataWithCache } from '../../../api';
import { CommentsItem } from './CommentsItem';

export const Comments = ({ source }) => {
  const { sort } = useSettings();

  return (
    <Component>
      <Title>Comments</Title>

      <Container>
        <DataWithCache
          sourceName={source}
          sourceType=""
          dataType="array"
          chunkSize={4}
          params={{ sort }}
        >
          {({ data, loading }) => (
            <Inner>
              {data?.length && !loading ? (
                data.map((item, id) => <CommentsItem key={id} data={item} />)
              ) : (
                <Loader
                  size={18}
                  color="#111"
                  className={`${classnamePrefix}-spinner-component`}
                />
              )}
            </Inner>
          )}
        </DataWithCache>
      </Container>
    </Component>
  );
};

const Component = styled.div.attrs({
  className: `${classnamePrefix}-comments-component`
})`
  max-width: 980px;
  width: 100%;
  margin: 32px auto 0;
`;

const Title = styled.h1.attrs({
  className: `${classnamePrefix}-comments-title`
})`
  font-size: 16px;
  font-weight: 700;
  color: #1a2e3b;
`;

const Inner = styled.div.attrs({
  className: `${classnamePrefix}-comments-commentsInner`
})`
  margin-top: 20px;
`;

const Container = styled.div.attrs({
  className: `${classnamePrefix}-comments-comments`
})``;
